export default class MediaRecorder {
  constructor(stream) {
    this.stream = stream
    this.onError = undefined
    this.onStop = undefined
    this.onStart = undefined

    this.chunks = []

    this.adapter = new window.MediaRecorder(this.stream, {})

    this.adapter.ondataavailable = ({ data }) => {
      this.chunks.push(data)
    }

    this.adapter.onstop = () => {
      if (this.onStop) this.onStop(this.getBlob())
    }

    this.adapter.onpause = () => {
      if (this.onStop) this.onStop(this.getBlob())
    }

    this.adapter.onstart = () => {
      if (this.onStart) this.onStart()
    }

    this.adapter.onresume = () => {
      if (this.onStart) this.onStart()
    }

    const AudioContext = window.AudioContext || window.webkitAudioContext
    this.context = new AudioContext()
  }

  getBlob() {
    const type = this.adapter.mimeType || 'audio/webm'
    const blob = new window.Blob(this.chunks, { type })
    this.chunks = []
    return blob
  }

  getStream() {
    return this.stream
  }

  getContext() {
    return this.context
  }

  start() {
    this.promise = new Promise((resolve, reject) => {
      this.onStart = resolve
      this.onError = reject
    })

    this.adapter.start()

    return this.promise
  }

  stop() {
    this.promise = new Promise((resolve, reject) => {
      this.onStop = resolve
      this.onError = reject
    })

    this.adapter.stop()

    return this.promise
  }
}
